const colorThemes = {
  // selected_colors: {
  //   text: colors.grey_800, // Body foreground color
  //   background: colors.white, // Body background color
  //   primary: colors.blue_500, // Primary brand color for links, buttons, etc.
  //   secondary: colors.blue_900, // A secondary brand color for alternative styling
  //   accent: colors.black, // A contrast color for emphasizing UI
  //   muted: colors.grey_200, // A background color for highlighting text
  //   error: colors.dark_grey_200, // A faint color for backgrounds, borders, and accents that do not require high contrast with the background color
  // },
  id: 'light',
  text: '#000', // Body foreground color
  background: '#fff', // Body background color
  primary: '#00f', // Primary brand color for links, buttons, etc.
  secondary: '#00a', // A secondary brand color for alternative styling
  highlight: '#ededff', // A background color for highlighting text
  accent: '#c0f', // A contrast color for emphasizing UI
  error: '#c30', // A faint color for backgrounds, borders, and accents that do not require high contrast with the background color
  gray: '#eee',
  lightgray: '#fafafa',

  // Grid colors
  strokeColor: '#dfdfdf',
  selectedHeaderColor: '#5f6368',
  gridHeader: '#f5f6f5',
  underSelectionCellColor: '#e4e6e5',

  tertiary: '#f5f6f5',

  midgray: '#777',
  muted: '#777',
  modes: {
    dark: {
      id: 'dark',
      text: '#fff',
      background: '#000',
      primary: '#0cf',
      secondary: '#f0e',
      gray: '#222',
      lightgray: '#111',
      highlight: '#001119',

      gridHeader: '#0c0c0c',
      strokeColor: '#191919',
      underSelectionCellColor: '#202120',
      tertiary: '#0c0c0c'
    },
    // cyan: {
    //   id: 'cyan',
    //   text: '#023',
    //   background: '#0ff',
    //   primary: '#03c',
    //   secondary: '#01a',
    //   gray: '#0cc',
    //   lightgray: '#0ee',
    //   highlight: '#0de',

    //   gridHeader: '#66ffff',
    //   strokeColor: '#00e5e5',
    //   underSelectionCellColor: '#99ffff',
    //   tertiary: '#66ffff',
    // },
    // gray: {
    //   id: 'gray',
    //   text: '#eef',
    //   background: '#333336',
    //   primary: '#09f',
    //   secondary: '#0bf',
    //   gray: '#55555a',
    //   lightgray: '#444448',
    //   highlight: '#33444c',
    // },
    // book: {
    //   id: 'book',
    //   text: '#322',
    //   background: '#fff9f9',
    //   primary: '#c30',
    //   secondary: '#400',
    //   gray: '#e9e6e6',
    //   lightgray: '#f9f6f6',

    //   strokeColor: '#e5e0e0',
    //   underSelectionCellColor: '#ccc7c7',
    // },
    // magenta: {
    //   id: 'magenta',
    //   text: '#203',
    //   background: '#f3f',
    //   primary: '#208',
    //   secondary: '#106',
    //   gray: '#c0c',
    //   lightgray: '#e0e',

    //   gridHeader: '#ff47ff',
    //   strokeColor: '#e52de5',
    //   underSelectionCellColor: '#ff70ff',
    //   tertiary: '#ff47ff',
    // },
  },
};

export const colors = {
  // ...colorThemes,
  light: {
    id: 'light',
    text: '#000', // Body foreground color
    background:   '#f5f8fa', // #fff Body background color
    primary: '#00f', // Primary brand color for links, buttons, etc.
    secondary: '#00a', // A secondary brand color for alternative styling
    highlight: '#ededff', // A background color for highlighting text
    accent: '#c0f', // A contrast color for emphasizing UI
    error: '#c30', // A faint color for backgrounds, borders, and accents that do not require high contrast with the background color
    gray: '#eee',
    lightgray: '#fafafa',
  
    // Grid colors
    strokeColor: '#dfdfdf',
    selectedHeaderColor: '#5f6368',
    gridHeader: '#f5f6f5',
    underSelectionCellColor: '#e4e6e5',
  },
  dark: {
    id: 'dark',

    // text: '#fff',
    // background: '#000',
    // primary: '#0cf',
    // secondary: '#f0e',

    background: "#1A202C", //"#161718",
    text: "#FFFFFF",
    primary: "#4299E1",
    secondary: "#667EEA",

    gray: '#222',
    lightgray: '#111',
    highlight: '#001119',

    gridHeader: '#0c0c0c',
    strokeColor: '#191919',
    underSelectionCellColor: '#202120',
    tertiary: '#0c0c0c'
  }  
};
export const extraColors = {
  current: 'currentColor',
  black: '#000000',
  white: '#ffffff',
  charcoal: '#36454f',
  aliceblue: '#f0f8ff',
  antiquewhite: '#faebd7',
  aqua: '#0ff',
  aquamarine: '#7fffd4',
  azure: '#f0ffff',
  beige: '#f5f5dc',
  bisque: '#ffe4c4',
  blanchedalmond: '#ffebcd',
  blue: '#00f',
  tuftsblue: '#4B87C8',
  blueviolet: '#8a2be2',
  brown: '#a52a2a',
  blueberry: '#5292f7',
  burlywood: '#deb887',
  burntsienna: '#ea7e5d',
  cadetblue: '#5f9ea0',
  chartreuse: '#7fff00',
  chocolate: '#d2691e',
  coral: '#ff7f50',
  cornflowerblue: '#6495ed',
  cornsilk: '#fff8dc',
  crimson: '#dc143c',
  cyan: '#0ff',
  darkblue: '#00008b',
  darkcyan: '#008b8b',
  darkgoldenrod: '#b8860b',
  darkgray: '#a9a9a9',
  darkgreen: '#006400',
  darkgrey: '#a9a9a9',
  darkkhaki: '#bdb76b',
  darkmagenta: '#8b008b',
  darkolivegreen: '#556b2f',
  darkorange: '#ff8c00',
  darkorchid: '#9932cc',
  darkred: '#8b0000',
  darksalmon: '#e9967a',
  darkseagreen: '#8fbc8f',
  darkslateblue: '#483d8b',
  darkslategray: '#2f4f4f',
  darkslategrey: '#2f4f4f',
  darkturquoise: '#00ced1',
  darkviolet: '#9400d3',
  deeppink: '#ff1493',
  deepskyblue: '#00bfff',
  dimgray: '#696969',
  dimgrey: '#696969',
  dodgerblue: '#1e90ff',
  firebrick: '#b22222',
  floralwhite: '#fffaf0',
  forestgreen: '#228b22',
  fuchsia: '#f0f',
  gainsboro: '#dcdcdc',
  ghostwhite: '#f8f8ff',
  gold: '#ffd700',
  goldenrod: '#daa520',
  gray: '#808080',
  green: '#008000',
  greenyellow: '#adff2f',
  grey: '#808080',
  honeydew: '#f0fff0',

  hotpink: '#ff69b4',
  indianred: '#cd5c5c',
  indigo: '#4b0082',
  ivory: '#fffff0',
  khaki: '#f0e68c',
  lavender: '#e6e6fa',
  lavenderblush: '#fff0f5',
  lawngreen: '#7cfc00',
  lemonchiffon: '#fffacd',
  lightblue: '#add8e6',
  lightcoral: '#f08080',
  lightcyan: '#e0ffff',
  lightgoldenrodyellow: '#fafad2',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  lightgrey: '#d3d3d3',
  lightpink: '#ffb6c1',
  lightsalmon: '#ffa07a',
  lightseagreen: '#20b2aa',
  lightskyblue: '#87cefa',
  lightslategray: '#789',
  lightslategrey: '#789',
  lightsteelblue: '#b0c4de',
  lightyellow: '#ffffe0',
  lime: '#0f0',
  limegreen: '#32cd32',
  linen: '#faf0e6',
  magenta: '#f0f',
  maroon: '#800000',
  mediumaquamarine: '#66cdaa',
  mediumblue: '#0000cd',
  mediumorchid: '#ba55d3',
  mediumpurple: '#9370db',
  mediumseagreen: '#3cb371',
  mediumslateblue: '#7b68ee',
  mediumspringgreen: '#00fa9a',
  mediumturquoise: '#48d1cc',
  mediumvioletred: '#c71585',
  midnightblue: '#191970',
  mintcream: '#f5fffa',
  mistyrose: '#ffe4e1',
  moccasin: '#ffe4b5',
  navajowhite: '#ffdead',
  navy: '#000080',
  oldlace: '#fdf5e6',
  olive: '#808000',
  olivedrab: '#6b8e23',
  orange: '#ffa500',
  orangered: '#ff4500',
  orchid: '#da70d6',
  palegoldenrod: '#eee8aa',
  palegreen: '#98fb98',
  paleturquoise: '#afeeee',
  palevioletred: '#db7093',
  papayawhip: '#ffefd5',
  peachpuff: '#ffdab9',
  peru: '#cd853f',
  pink: '#ffc0cb',
  plum: '#dda0dd',
  powderblue: '#b0e0e6',
  purple: '#800080',
  rebeccapurple: '#663399',
  red: '#f00',
  rosybrown: '#bc8f8f',
  royalblue: '#4169e1',
  saddlebrown: '#8b4513',
  salmon: '#fa8072',
  sandybrown: '#f4a460',
  seagreen: '#2e8b57',
  seashell: '#fff5ee',
  sienna: '#a0522d',
  silver: '#c0c0c0',
  skyblue: '#87ceeb',
  slateblue: '#6a5acd',
  slategray: '#708090',
  slategrey: '#708090',
  shuttlegrey: '#5f6368',
  snow: '#fffafa',
  springgreen: '#00ff7f',
  steelblue: '#4682b4',
  tan: '#d2b48c',
  teal: '#008080',
  thistle: '#d8bfd8',
  tomato: '#ff6347',
  turquoise: '#40e0d0',
  violet: '#ee82ee',
  wheat: '#f5deb3',
  lilywhite: '#e4e6e5',
  whitesmoke: '#f5f5f5',
  whitesmoke_1: '#f5f6f5',
  yellow: '#ff0',
  yellowgreen: '#9acd32',
  transparent: 'transparent',
  mediumgray: '#aca9a9',

  grey_900: '#1a202c',
  grey_800: '#2d3748',
  grey_700: '#4a5568',
  grey_600: '#718096',
  grey_500: '#a0aec0',
  grey_400: '#cbd5e0',
  grey_300: '#e2e8f0',
  grey_200: '#edf2f7',
  grey_100: '#f7fafc',
  grey_79: '#dfdfdf', // 303130 c9c9c9 #FFFFFF,

  dark_grey_50: '#f2f2f2',
  dark_grey_100: '#d9d9d9',
  dark_grey_200: '#bfbfbf',
  dark_grey_300: '#a6a6a6',
  dark_grey_400: '#8c8c8c',
  dark_grey_500: '#737373',
  dark_grey_600: '#595959',
  dark_grey_700: '#404040',
  dark_grey_800: '#262626',
  dark_grey_900: '#0d0d0d',

  red_900: '#610404',
  red_800: '#780A0A',
  red_700: '#911111',
  red_600: '#A61B1B',
  red_500: '#BA2525',
  red_400: '#D64545',
  red_300: '#E66A6A',
  red_200: '#F29B9B',
  red_100: '#FACDCD',

  orange_900: '#7b341e',
  orange_800: '#9c4221',
  orange_700: '#c05621',
  orange_600: '#dd6b20',
  orange_500: '#ed8936',
  orange_400: '#f6ad55',
  orange_300: '#fbd38d',
  orange_200: '#fffaf0',
  orange_100: '#fffaf0',

  yellow_900: '#744210',
  yellow_800: '#975a16',
  yellow_700: '#b7791f',
  yellow_600: '#d69e2e',
  yellow_500: '#ecc94b',
  yellow_400: '#f6e05e',
  yellow_300: '#faf089',
  yellow_200: '#fefcbf',
  yellow_100: '#fffff0',

  green_900: '#22543d',
  green_800: '#276749',
  green_700: '#2f855a',
  green_600: '#38a169',
  green_500: '#48bb78',
  green_400: '#68d391',
  green_300: '#9ae6b4',
  green_200: '#c6f6d5',
  green_100: '#f0fff4',

  teal_900: '#234e52',
  teal_800: '#285e61',
  teal_700: '#2c7a7b',
  teal_600: '#319795',
  teal_500: '#38b2ac',
  teal_400: '#4fd1c5',
  teal_300: '#81e6d9',
  teal_200: '#b2f5ea',
  teal_100: '#e6fffa',

  blue_900: '#2a4365',
  blue_800: '#2c5282',
  blue_700: '#2b6cb0',
  blue_600: '#3182ce',
  blue_500: '#4299e1',
  blue_400: '#63b3ed',
  blue_300: '#90cdf4',
  blue_200: '#bee3f8',
  blue_100: '#ebf8ff',

  indigo_900: '#3c366b',
  indigo_800: '#434190',
  indigo_700: '#4c51bf',
  indigo_600: '#5a67d8',
  indigo_500: '#667eea',
  indigo_400: '#7f9cf5',
  indigo_300: '#a3bffa',
  indigo_200: '#c3dafe',
  indigo_100: '#ebf4ff',

  cyan_50: '#EDFDFD',
  cyan_100: '#C4F1F9',
  cyan_200: '#9DECF9',
  cyan_300: '#76E4F7',
  cyan_400: '#0BC5EA',
  cyan_500: '#00B5D8',
  cyan_600: '#00A3C4',
  cyan_700: '#0987A0',
  cyan_800: '#086F83',
  cyan_900: '#065666',

  purple_900: '#44337a',
  purple_800: '#553c9a',
  purple_700: '#6b46c1',
  purple_600: '#805ad5',
  purple_500: '#9f7aea',
  purple_400: '#b794f4',
  purple_300: '#d6bcfa',
  purple_200: '#e9d8fd',
  purple_100: '#faf5ff',

  pink_900: '#702459',
  pink_800: '#97266d',
  pink_700: '#b83280',
  pink_600: '#d53f8c',
  pink_500: '#ed64a6',
  pink_400: '#f687b3',
  pink_300: '#fbb6ce',
  pink_200: '#fed7e2',
  pink_100: '#fff5f7',

  linkedin_50: '#E8F4F9',
  linkedin_100: '#CFEDFB',
  linkedin_200: '#9BDAF3',
  linkedin_300: '#68C7EC',
  linkedin_400: '#34B3E4',
  linkedin_500: '#00A0DC',
  linkedin_600: '#008CC9',
  linkedin_700: '#0077B5',
  linkedin_800: '#005E93',
  linkedin_900: '#004471',

  facebook_50: '#E8F4F9',
  facebook_100: '#D9DEE9',
  facebook_200: '#B7C2DA',
  facebook_300: '#6482C0',
  facebook_400: '#4267B2',
  facebook_500: '#385898',
  facebook_600: '#314E89',
  facebook_700: '#29487D',
  facebook_800: '#223B67',
  facebook_900: '#1E355B',

  messenger_50: '#D0E6FF',
  messenger_100: '#B9DAFF',
  messenger_200: '#A2CDFF',
  messenger_300: '#7AB8FF',
  messenger_400: '#2E90FF',
  messenger_500: '#0078FF',
  messenger_600: '#0063D1',
  messenger_700: '#0052AC',
  messenger_800: '#003C7E',
  messenger_900: '#002C5C',

  whatsapp_50: '#dffeec',
  whatsapp_100: '#b9f5d0',
  whatsapp_200: '#90edb3',
  whatsapp_300: '#65e495',
  whatsapp_400: '#3cdd78',
  whatsapp_500: '#22c35e',
  whatsapp_600: '#179848',
  whatsapp_700: '#0c6c33',
  whatsapp_800: '#01421c',
  whatsapp_900: '#001803',

  twitter_50: '#E5F4FD',
  twitter_100: '#C8E9FB',
  twitter_200: '#A8DCFA',
  twitter_300: '#83CDF7',
  twitter_400: '#57BBF5',
  twitter_500: '#1DA1F2',
  twitter_600: '#1A94DA',
  twitter_700: '#1681BF',
  twitter_800: '#136B9E',
  twitter_900: '#0D4D71',

  telegram_50: '#E3F2F9',
  telegram_100: '#C5E4F3',
  telegram_200: '#A2D4EC',
  telegram_300: '#7AC1E4',
  telegram_400: '#47A9DA',
  telegram_500: '#0088CC',
  telegram_600: '#007AB8',
  telegram_700: '#006BA1',
  telegram_800: '#005885',
  telegram_900: '#003F5E',

  whiteAlpha_50: 'rgba(255, 255, 255, 0.04)',
  whiteAlpha_100: 'rgba(255, 255, 255, 0.06)',
  whiteAlpha_200: 'rgba(255, 255, 255, 0.08)',
  whiteAlpha_300: 'rgba(255, 255, 255, 0.16)',
  whiteAlpha_400: 'rgba(255, 255, 255, 0.24)',
  whiteAlpha_500: 'rgba(255, 255, 255, 0.36)',
  whiteAlpha_600: 'rgba(255, 255, 255, 0.48)',
  whiteAlpha_700: 'rgba(255, 255, 255, 0.64)',
  whiteAlpha_800: 'rgba(255, 255, 255, 0.80)',
  whiteAlpha_900: 'rgba(255, 255, 255, 0.92)',

  blackAlpha_50: 'rgba(0, 0, 0, 0.04)',
  blackAlpha_100: 'rgba(0, 0, 0, 0.06)',
  blackAlpha_200: 'rgba(0, 0, 0, 0.08)',
  blackAlpha_300: 'rgba(0, 0, 0, 0.16)',
  blackAlpha_400: 'rgba(0, 0, 0, 0.24)',
  blackAlpha_500: 'rgba(0, 0, 0, 0.36)',
  blackAlpha_600: 'rgba(0, 0, 0, 0.48)',
  blackAlpha_700: 'rgba(0, 0, 0, 0.64)',
  blackAlpha_800: 'rgba(0, 0, 0, 0.80)',
  blackAlpha_900: 'rgba(0, 0, 0, 0.92)',
}
export type Colors = typeof colors;

export type ColorScheme =
  | 'grey'
  | 'dark_grey'
  | 'orange'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'green'
  | 'teal'
  | 'blue'
  | 'cyan'
  | 'purple'
  | 'pink'
  | 'indigo'
  | 'linkedin'
  | 'facebook'
  | 'messenger'
  | 'whatsapp'
  | 'twitter'
  | 'telegram';
